import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import logo from '../assets/logo.svg';

const HeaderAnimated = ({ color }) => {
  const [topPosition, setTopPosition] = useState();
  const [width, setWidth] = useState(0);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleSizeChange = () => {
        if (window.innerWidth > 767) {
          const maxWidth = window.innerWidth * 0.75;
          const minWidth = 211.250;
          const newWidth = maxWidth - (window.scrollY / window.innerHeight * 1200);

          const minTopPosition = 28;
          const maxTopPosition = window.innerHeight;
          const newTopPosition = maxTopPosition / 2 - window.scrollY;

          if (newTopPosition < minTopPosition) {
            setTopPosition(minTopPosition);
          } else if (newTopPosition > maxTopPosition) {
            setTopPosition(maxTopPosition);
          } else {
            setTopPosition(newTopPosition);
          }

          if (newWidth < minWidth) {
            setWidth(minWidth);
          } else if (newWidth > maxWidth) {
            setWidth(maxWidth);
          } else {
            setWidth(newWidth);
          }

          setOpacity(window.scrollY / (window.innerHeight - 48));
        };
      };

      window.addEventListener("resize", handleSizeChange);
      window.addEventListener("scroll", handleSizeChange);
      handleSizeChange();
    }
  }, []);

  return (
    <div className="header-large header-full-screen center-children section">
      <div className={`header-color header-full-screen bg bg-color-${color} bg-image-header`}></div>
      <div className="header-image header-full-screen"></div>
      <div className="header-logo-container">
        <div className={`header-small-strip bg bg-color-${color} bg-image-white`} style={{ opacity: opacity }} />
        <div className="header-logo-image" style={{ opacity: topPosition ? 1 : 0, top: topPosition }}>
          <Link to="/">
            <img src={logo} className="header-logo logo-large" alt="logo" width={width ? `${width}px` : null} />
          </Link>
        </div>
      </div>
    </div>
  );
};
export default HeaderAnimated;

